import { render, staticRenderFns } from "./SortLocation.vue?vue&type=template&id=2bb475f8&lang=pug&"
import script from "./SortLocation.vue?vue&type=script&lang=js&"
export * from "./SortLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports